module.exports = __webpack_public_path__ + "media/You_Are_Holy_Brandon_Roberson_Official_Video.6cc0c4a4.mp3";